<template lang="html">
  <div class="team-member-profile container">
    <span
      v-editable="resource.columns.name"
      class="team-member-profile__name"
    />
    <div class="team-member-profile__position">
      <span v-editable="resource.columns.position" />
      <template v-if="resource.columns.email && resource.columns.position">
        <span class="team-member-profile__comma">,&nbsp;</span>
      </template>
      <span v-if="resource.columns.email" class="team-member-profile__email">
        <a :href="'mailto:' + resource.columns.email">{{
          resource.columns.email
        }}</a>
      </span>
    </div>
    <Media
      :path="resource.columns.asset"
      :center="false"
      class="team-member-profile__image"
    />
    <LabeledContent>
      <Headline slot="headline" :size="2">
        Zur Person
      </Headline>
      <div v-editable.html="resource.columns.profile" />
    </LabeledContent>
  </div>
</template>

<script>
import LabeledContent from "beisheim/components/elements/labeled-content";
import Media from "beisheim/components/elements/media";
import Headline from "beisheim/components/elements/headline";
import matomoPageTracker from 'beisheim/mixins/matomo-page-tracker'
import editable from "@i22/frontend-cms-utils/mixins/editable";

export default {
  components: {
    LabeledContent,
    Headline,
    Media,
  },
  mixins: [ editable, matomoPageTracker ],
  head () {
    return {
      title: this.resource.columns.title,
    };
  },
};
</script>

<style lang="scss">
@import "~beisheim/scss/scale";
@import "~beisheim/scss/fluid-type";
@import "~beisheim/scss/grid";
@import "~beisheim/scss/breakpoints";
@import "~beisheim/scss/font";
@import "~beisheim/scss/font-sizes";

.team-member-profile {
  &__name {
    display: block;
    font-size: font-size(4);
    margin-bottom: scale(2);
  }
  &__position {
    display: block;
    margin-bottom: scale(8);
  }
  &__email {
    text-decoration: underline;
    @include to(2) {
      display: block;
    }
  }
  &__image {
    width: 100%;
    max-width: 480px;
    margin-bottom: scale(12);
  }
  &__container {
    display: flex;
    flex-direction: column;
    @include from(3) {
      justify-content: space-between;
      flex-direction: row;
    }
  }
  &__slug {
    font-size: font-size(2);
    margin-bottom: scale(4);
  }
  &__description {
    @include from(3) {
      width: grid-columns(12);
    }
    @include from(6) {
      width: max-grid-columns(12);
    }
  }

  margin: scale(1) auto;
  min-width: $min-width;
  max-width: $max-width;
  @include grid-spacing(margin-bottom, 2);
  @include from(4) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    @include grid-spacing(padding-left, 3);
    @include grid-spacing(padding-right, 3);
  }

  &__comma {
    margin-left: -4px;
  }
}
</style>
